module.exports = __webpack_public_path__ + "img/modelo-cantina-gal-4.6639e1f2.jpg";